import IContactNotification from "@myinnsworth/models/contact/IContactNotification";
import NotificationListItem from "./notificationListItem";

export interface INotificationListGroupProps {
    title: string;
    notifications: Array<IContactNotification>;
}

export default function NotificationsListGroup(props: INotificationListGroupProps) {
    return (<>
        <div className="notification-group">
            <div className="notification-group-header">
                {props.title}
            </div>
            <div className="notification-group-body">
                {props.notifications.map((n, i) => <NotificationListItem key={i} notification={n} />)}
            </div>
        </div>
    </>);
}